import { Icon } from 'Components/shared/Icon';
import { MobXProviderContext } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { ContactSaveActionProps } from './index.types';

/**
 * Reusable component for the "Save this contact" action button
 */
export const ContactSaveAction = ({ contact }: ContactSaveActionProps) => {
  const navigate = useNavigate();
  const { person: personStore } =
    React.useContext<RootStoreProps>(MobXProviderContext);

  const handleSaveContact = useCallback(() => {
    const currentPhoneNumber =
      typeof contact === 'string' ? contact : contact.phoneNumber;

    // Set the contact as the edit contact so it pre-fills the form
    personStore.setEditContact({
      phoneNumbers: [
        {
          number: currentPhoneNumber,
          type: 'mobile',
          primary: true,
        },
      ],
    } as ContactModelV2);
    personStore.setIsAddingContact(true);

    // Navigate to the create contact page
    void navigate('/addressBook/contact');
  }, [contact, navigate, personStore]);

  return (
    <article
      className="py-2 px-2 w-full flex flex-row items-center rounded-lg justify-between cursor-pointer hover:bg-accent"
      onClick={handleSaveContact}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSaveContact();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Save this contact"
    >
      <div className="flex flex-row items-center gap-1.5">
        <Icon icon="add-user" />
        <p className="text-[13px]">Save this contact</p>
      </div>
    </article>
  );
};
